


















































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Software"
})
export default class Software extends Vue {}
